import $routerNames from '@/constants/router/account';
import pseudoMixin from './render';

export default {
  name: 'LinkClan',
  ...pseudoMixin($routerNames.CLAN),
};
